import React from "react";
import constants from "../../constants";

const brandLogo = constants.brandLogo;

export default function Login(props) {
	return (
		<React.Fragment>
			<div className="logo-container">
				<img src={`/assets/images/${brandLogo}`} alt="brand logo" />
				{constants.brandTagLine ? (
					<p className="logo-tagline">Marketing Automation. Simplified.</p>
				) : (
					""
				)}
			</div>
			<div className="login-content">
				<h4 className="login-header">{props.header}</h4>
				{props.loginType === "signup" ? (
					<h4>Limited offer for 14 days free trial, sign up now!</h4>
				) : null}
				<img
					className="login-image"
					src={props.image}
					style={props.imgStyle}
					alt="login"
				/>
			</div>
		</React.Fragment>
	);
}
